export const REDUCER_NAME = "nationalAppearances";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_NATIONALTEAMAPPEARANCES = `${REDUCER_NAME}/SET_NATIONALTEAMAPPEARANCES`;

export const getKey = (data) => `${data.nationalTeamId}`;
